// extracted by mini-css-extract-plugin
export var hidden = "_vf-0";